import axios from 'axios'
import { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovoTipoDeobservacao.css'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser();
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdObservacaoSubGrupo: 0,
    IdObservacaoGrupo: sessionStorage.IdObservacaoGrupoEdit,
    IdObservacaoTipo: sessionStorage.IdObservacaoTipoEdit,
    IdEmpresa: user[0].IdEmpresa,
    sbgNumero: 0,
    sbgDescricao: '',
    sbgStatus: 1,
    sbgObservacoes: '',
    sbgCriadoPor: user[0].pesEmail,
    sbgCriadoEm: newDate,
    sbgAlteradoPor: user[0].pesEmail,
    sbgAlteradoEm: newDate,
    sbgCodigoGUID: uuidv4
  })

  function handleInputChange(event) {
    const { name, value } = event.target;
    setCampos({
      ...campos,
      [name]: value
    });
  }

    function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/observacaosubgrupo', campos)
      .then(response => {
        if (response.status === 201) {
          alert(response.data.message)
          window.location.reload()
        } else {
          alert(response.data.message)
        }
      })
  }
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadrao">
        Novo Sub Grupo
      </button>

      {modal && (
        <div className="overlay">
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>Novo Sub Grupo de Questões
              <hr className='hrTitleModal' />
              </h1>
              <button className="close-modal" onClick={toggleModal}>
                X
              </button>
            </div>

            <form onSubmit={handleFormSubmit}>
                <div className="linhaTipObs" style={{ width: '100%'}}>
                    <tr>
                        <th><label>Ordem</label></th>
                        <th><label>Descrição:</label></th>
                    </tr>
                    <tr>
                        <td>
                            <input
                                type="number"
                                id="sbgNumero"
                                name="sbgNumero"
                                min={1}
                                value={campos.sbgNumero}
                                onChange={handleInputChange}
                                required>
                            </input>
                        </td>
                        <td style={{ width: '100%' }}>
                            <input
                                type="text"
                                id="sbgDescricao"
                                name="sbgDescricao"
                                value={campos.sbgDescricao}
                                onChange={handleInputChange}
                                required >
                            </input>
                        </td>
                    </tr>
                </div>

                <label>
                    Observação:
                </label>
                <textarea
                    id="sbgObservacoes"
                    name="sbgObservacoes"
                    value={campos.sbgObservacoes}
                    onChange={handleInputChange}
                ></textarea>

                <div className="caixaSalvarPadrao">
                <button type='submit'>
                  Salvar SubGrupo
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}